class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
		this.submitButton = this.querySelector('button[data-submit-button]');

		this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));

		const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
		if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

		this.closest('menu-drawer')?.addEventListener('close-menu-drawer', () => {
			this.querySelector('form')?.reset();
		});
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener('popstate', onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll('.js-facet-remove').forEach((element) => {
			element.classList.toggle('disabled', disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById('ProductCount');
		const countContainerDesktop = document.getElementById('ProductCountDesktop');
		document
			.getElementById('ProductGridContainer')
			.querySelector('.collection')
			.classList.add('loading');
		if (countContainer) {
			countContainer.classList.add('loading');
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add('loading');
		}

		sections.forEach((section) => {
			const url = `${window.location.pathname}?${searchParams}`;
			const filterDataUrl = (element) => element.url === url;
			console.log('Rendering URL:', url);

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderPageWithUrls(displayUrl, fetchUrl, event, updateURLHash = true) {
		// Extract search params for tracking
		const urlObj = new URL(displayUrl, window.location.origin);
		const searchParams = urlObj.search.slice(1);
		
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		
		// Set loading states
		FacetFiltersForm.setLoadingStates(true);

		sections.forEach((section) => {
			const filterDataUrl = (element) => element.url === fetchUrl;
			console.log('Display URL:', displayUrl);
			console.log('Fetch URL:', fetchUrl);

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(fetchUrl, event);
		});

		if (updateURLHash) {
			// Update browser URL with display URL
			const displayUrlObj = new URL(displayUrl, window.location.origin);
			history.pushState(
				{ searchParams },
				'',
				displayUrlObj.pathname + displayUrlObj.search
			);
		}
	}

	static setLoadingStates(isLoading) {
		const countContainer = document.getElementById('ProductCount');
		const countContainerDesktop = document.getElementById('ProductCountDesktop');
		const productGrid = document.getElementById('ProductGridContainer')?.querySelector('.collection');
		
		if (productGrid) {
			productGrid.classList.toggle('loading', isLoading);
		}
		if (countContainer) {
			countContainer.classList.toggle('loading', isLoading);
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.toggle('loading', isLoading);
		}
	}

	static renderSectionFromFetch(url, event) {
		return fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderTabsFilter(html, event);

				FacetFiltersForm.renderTagFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderTabsFilter(html, event);

		FacetFiltersForm.renderTagFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
	}

	static renderProductGridContainer(html) {
		document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
			.parseFromString(html, 'text/html')
			.getElementById('ProductGridContainer').innerHTML;

		if (document.querySelector('load-more-btn') && !customElements.get('load-more-btn')) {
			customElements.define('load-more-btn', window.LoadMoreBtn);
		}
	}

	static renderProductCount(html) {
		const count = new DOMParser()
			.parseFromString(html, 'text/html')
			.getElementById('ProductCount').innerHTML;
		const container = document.getElementById('ProductCount');
		const containerDesktop = document.getElementById('ProductCountDesktop');
		container.innerHTML = count;
		container.classList.remove('loading');
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove('loading');
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		const facetDetailsElements = parsedHTML.querySelectorAll(
			'#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter',
		);
		
		const isCollectionHandleFilter = event && 
			event.target.closest('custom-link')?.getAttribute('data-show-collection-handle') &&
			event.target.closest('collection-tag-filters');
		
		const matchesIndex = (element) => {
			if (isCollectionHandleFilter) {
				return false;
			}
			// Original logic for facet form filters
			const jsFilter = event ? event.target.closest('.js-filter') : undefined;
			return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
		};
		
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element),
		);
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			const jsEl = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
			if(jsEl){
				jsEl.innerHTML =
				element.innerHTML;
			}
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
	}

	static renderTagFilters(html, event) {
		const currentUrl = new URL(window.location);
		const filteredCollection = currentUrl.searchParams.get('filtered-collection');
		
		if (filteredCollection) {
			return;
		}
		
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
		const CollectionTagFilters = parsedHTML.querySelector('collection-tag-filters');
		if (!CollectionTagFilters) return;
		const currentCollectionTagFilters = document.querySelector('collection-tag-filters');
		currentCollectionTagFilters.outerHTML = CollectionTagFilters.outerHTML;
	}

	static renderTabsFilter(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
		const tagFilterTabs = parsedHTML.querySelector('tag-filter-tabs');
		if (tagFilterTabs) {
			const currentTagFilterTabs = document.querySelector('tag-filter-tabs');
			if(currentTagFilterTabs == event?.target) return;
			
			if (currentTagFilterTabs) {
				currentTagFilterTabs.outerHTML = tagFilterTabs.outerHTML;
			}
		}
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
		});

		document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector('.facets__selected');
		const sourceElement = source.querySelector('.facets__selected');

		if (sourceElement && targetElement) {
			target.querySelector('.facets__selected').outerHTML =
				source.querySelector('.facets__selected').outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			'',
			`${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
		);
	}

	static getSections() {
		return [
			{
				section: document.getElementById('product-grid').dataset.id,
			},
		];
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const form = event.target.closest('form');
		const formData = new FormData(form);
		
		this.processPriceRangeInputs(form, formData);
		
		const saintNameMetafieldData = this.getSaintNameMetafildData(formData);
		if (saintNameMetafieldData) {
			formData.set(saintNameMetafieldData.param, saintNameMetafieldData.value);
		}

		const { displayUrl, fetchUrl } = this.buildFormSubmissionUrls(formData);
		
		FacetFiltersForm.renderPageWithUrls(displayUrl, fetchUrl, event);

		this.closest('menu-drawer')?.closeMenuDrawer(event);
	}

	processPriceRangeInputs(form, formData) {
		const priceSlider = form.querySelector('price-range-slider');
		const priceRange = form.querySelector('price-range');
		
		if (priceSlider) {
			this.processPriceSliderInputs(priceSlider, formData);
		}
		
		if (priceRange) {
			this.processPriceRangeFields(priceRange, formData);
		}
	}

	processPriceSliderInputs(priceSlider, formData) {
		const minInput = priceSlider.querySelector('.price-range-slider__input--min');
		const maxInput = priceSlider.querySelector('.price-range-slider__input--max');
		
		if (minInput && maxInput) {
			const minValue = parseInt(minInput.value);
			const maxValue = parseInt(maxInput.value);
			const rangeMin = parseInt(minInput.min);
			const rangeMax = parseInt(maxInput.max);
			
			if (minValue === rangeMin) {
				formData.delete(minInput.name);
			}
			if (maxValue === rangeMax) {
				formData.delete(maxInput.name);
			}
		}
	}

	processPriceRangeFields(priceRange, formData) {
		const inputs = priceRange.querySelectorAll('input');
		const minInput = inputs[0];
		const maxInput = inputs[1];
		
		if (minInput && maxInput) {
			const minValue = parseInt(minInput.value) || 0;
			const maxValue = parseInt(maxInput.value) || parseInt(maxInput.getAttribute('max'));
			const rangeMin = parseInt(minInput.getAttribute('min')) || 0;
			const rangeMax = parseInt(maxInput.getAttribute('max'));
			
			// Remove price parameters if they match the min/max allowable values or are empty
			if (minValue === rangeMin || minInput.value === '') {
				formData.delete(minInput.name);
			}
			if (maxValue === rangeMax || maxInput.value === '') {
				formData.delete(maxInput.name);
			}
		}
	}

	buildFormSubmissionUrls(formData) {
		const currentUrl = new URL(window.location);
		const filteredCollection = currentUrl.searchParams.get('filtered-collection');
		const searchParams = new URLSearchParams(formData).toString();
		
		if (filteredCollection) {
			return this.buildDualUrls(searchParams, filteredCollection);
		} else {
			return this.buildStandardUrls(searchParams);
		}
	}

	buildDualUrls(searchParams, filteredCollection) {
		const currentUrl = new URL(window.location);
		
		// Display URL: current path + form params + filtered-collection
		const displayUrl = this.buildDisplayUrl(currentUrl, searchParams, filteredCollection);
		
		// Fetch URL: target collection path + form params (without filtered-collection)
		const fetchUrl = this.buildFetchUrl(searchParams, filteredCollection);
		
		return { displayUrl, fetchUrl };
	}

	buildDisplayUrl(currentUrl, searchParams, filteredCollection) {
		// Build URL manually to preserve multiple parameter values
		const paramsString = searchParams ? searchParams : '';
		const separator = paramsString ? '&' : '';
		
		return `${currentUrl.pathname}?${paramsString}${separator}filtered-collection=${encodeURIComponent(filteredCollection)}`;
	}

	buildFetchUrl(searchParams, filteredCollection) {
		// Preserve market information by using current URL as base
		const fetchUrl = new URL(window.location.href);
		const urlPathNameParts = fetchUrl.pathname.split('/');
		const marketPrefix = urlPathNameParts[0] != "collections" ? urlPathNameParts[0] : '';
		fetchUrl.pathname = `${marketPrefix}/collections/${filteredCollection}`;
		fetchUrl.search = searchParams ? `?${searchParams}` : '';
		return fetchUrl.toString();
	}

	buildStandardUrls(searchParams) {
		const currentUrl = new URL(window.location);
		const url = `${currentUrl.pathname}${searchParams ? `?${searchParams}` : ''}`;
		
		return { displayUrl: url, fetchUrl: url };
	}

	getSaintNameMetafildData(formData){
		const customFilterSelects = document.querySelectorAll("custom-filter-select")
		if(!customFilterSelects.length) return null

		const metafieldFilter = Array.from(customFilterSelects).find(select=>select.getSelectedMetafieldOption());
		if(!metafieldFilter) return null;
		

		const metafieldParam = metafieldFilter.getSelectedOption();
		if(!metafieldParam) return null;
		const value = metafieldParam.getAttribute("data-filtering-saint")
		const param = metafieldParam.getAttribute("data-metafield-filter-key")
		
		const getFormDataMetafield = formData.get(param);
		if(getFormDataMetafield && getFormDataMetafield == value) return null;
		
		return {value, param}
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		let url =
			event.currentTarget.href.indexOf('?') == -1
				? ''
				: event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
		
		// Check if getSaintNameMetafildData returns an object
		const searchParams = new URLSearchParams(url);
		const saintNameMetafieldData = this.getSaintNameMetafildData(searchParams);
		if (saintNameMetafieldData) {
			// Don't remove this value from searchParams, add it back
			searchParams.set(saintNameMetafieldData.param, saintNameMetafieldData.value);
			url = searchParams.toString();
		}
		
		FacetFiltersForm.renderPage(url);
	}
}

window.FacetFiltersForm = FacetFiltersForm;

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class CustomLink extends HTMLElement {
	constructor() {
		super();
		this.link = this.querySelector('a');
		this.link.setAttribute('title', this.link.innerText);
		this.collectionTagFiltersContainer = this.closest('.collection-tag-filters') || null;
		
		this.handleClick = this.handleClick.bind(this);
		
		this.link.addEventListener('click', this.handleClick);
		
		// Initialize price replacement for non-CA markets
		this.initializePriceReplacement();
	}

	handleClick(e) {
		e.preventDefault();
		
		this.setLoadingState(true);
		
		const { displayUrl, fetchUrl } = this.buildFilterUrl();
		
		this.navigateToUrl(displayUrl, fetchUrl, e);
		// this.updateActiveFilter();
	}

	setLoadingState(isLoading) {
		const countContainer = document.getElementById('ProductCount');
		const countContainerDesktop = document.getElementById('ProductCountDesktop');
		const productGrid = document.getElementById('ProductGridContainer')?.querySelector('.collection');
		
		if (productGrid) {
			productGrid.classList.toggle('loading', isLoading);
		}
		if (countContainer) {
			countContainer.classList.toggle('loading', isLoading);
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.toggle('loading', isLoading);
		}
	}

	initializePriceReplacement() {
		// Only process if this element has filter price data
		if (!this.hasFilterPrice()) return;
		
		// Skip if CA market (handled by Liquid)
		if (this.isCAMarket()) return;
		
		// Process price conversion for non-CA markets
		this.updateFilterPrice();
	}

	hasFilterPrice() {
		return Boolean(this.getAttribute('data-filter-price'));
	}

	isCAMarket() {
		return window.Shopify?.country === 'CA' || 
			   document.documentElement.lang === 'en-CA' ||
			   window.location.hostname.includes('.ca');
	}

	updateFilterPrice() {
		const priceElement = this.querySelector('.threshold-price');
		console.log('Price Element:', priceElement);
		if (!priceElement) return;

		const convertedPrice = this.calculateConvertedPrice();
		const formattedPrice = this.formatPrice(convertedPrice);
			
		this.updatePriceElement(priceElement, formattedPrice);
	}

	calculateConvertedPrice() {
		const basePrice = parseFloat(this.getAttribute('data-filter-price'));
		if (isNaN(basePrice)) return basePrice;

		const rate = Number(window.Shopify?.currency?.rate) || 1;
		// Base price is in cents, convert with rate and ensure whole number
		return Math.ceil((basePrice * rate) / 100);
	}

	formatPrice(price) {
		const currencySymbol = window.cartThreshold.currencySymbol;
		return `${price}${currencySymbol}`;
	}


	updatePriceElement(priceElement, formattedPrice) {
		priceElement.textContent = formattedPrice;
		priceElement.classList.remove('threshold-price-loading');
	}

	buildFilterUrl() {
		if (this.collectionTagFiltersContainer) {
			return this.buildCollectionFilterUrl();
		} else {
			const url = this.buildStandardUrl();
			return { displayUrl: url, fetchUrl: url };
		}
	}

	buildCollectionFilterUrl() {
		const showCollectionHandle = this.getAttribute('data-show-collection-handle');
		
		if (showCollectionHandle) {
			return this.buildCustomCollectionUrl(showCollectionHandle);
		} else {
			return this.buildStandardCollectionUrl();
		}
	}

	buildCustomCollectionUrl(showCollectionHandle) {
		const displayUrl = new URL(window.location.href);
		
		// Handle tag filtering
		this.applyTagFiltering(displayUrl);
		
		// Handle type filtering
		this.applyTypeFiltering(displayUrl);
		
		// Remove page parameter
		displayUrl.searchParams.delete('page');
		
		// Create fetchUrl preserving the full host and path structure
		const fetchUrl = new URL(window.location.href);
		const urlPathNameParts = fetchUrl.pathname.split('/').filter(item => item !== "");
		const marketPrefix = urlPathNameParts[0] != "collections" ? urlPathNameParts[0] : '';
		
		fetchUrl.pathname = `${marketPrefix}/collections/${showCollectionHandle}`;
		// Clear search params and copy from displayUrl
		fetchUrl.search = '';

		this.copySearchParams(displayUrl.searchParams, fetchUrl.searchParams);

		displayUrl.searchParams.set('filtered-collection', showCollectionHandle);
		
		return { displayUrl, fetchUrl };
	}

	copySearchParams(sourceParams, targetParams) {
		// Copy all search params preserving multiple values
		sourceParams.forEach((value, key) => {
			if (key !== 'filtered-collection') {
				targetParams.append(key, value);
			}
		});
	}

	buildStandardCollectionUrl() {
		// Start with current URL to preserve existing search parameters
		const url = new URL(window.location.href);
		
		// Handle tag filtering
		this.applyTagFiltering(url);
		
		// Handle type filtering
		this.applyTypeFiltering(url);

		this.removeCollectionParam(url);
		
		// Remove page parameter for fresh results
		url.searchParams.delete('page');
		
		return { displayUrl: url, fetchUrl: url };
	}

	removeCollectionParam(url) {
		url.searchParams.delete('filtered-collection');
	}

	applyTagFiltering(url) {
		const collectionBaseUrl = this.collectionTagFiltersContainer.getAttribute('data-collection-url');
		const filteringTags = this.getAttribute("data-filtering-tags");
		
		if (filteringTags && filteringTags.trim() !== '') {
			url.pathname = `${collectionBaseUrl}/${filteringTags}`;
		} else {
			// If no tag specified, use base collection URL (show all)
			url.pathname = `${collectionBaseUrl}/`;
		}
	}

	applyTypeFiltering(url) {
		const filterProductTypesStr = this.getAttribute("data-filtering-types");
		
		// Remove existing product_type params
		url.searchParams.delete('filter.p.product_type');
		
		if (filterProductTypesStr?.length) {
			const filterProductTypes = filterProductTypesStr.split(",").map(type => type.trim());
			filterProductTypes.forEach(type => {
				if (type) {
					url.searchParams.append('filter.p.product_type', type);
				}
			});
		}
		// If switching from block with type to block without type, types are already cleared
	}

	buildStandardUrl() {
		// For non-collection-tag-filters, preserve current behavior
		const url = new URL(`${this.link.href}${window.location.search}`);
		url.searchParams.delete('page');
		return url;
	}

	navigateToUrl(displayUrl, fetchUrl, event) {
		
		const displayUrlString = displayUrl.toString();
		const fetchUrlString = fetchUrl.toString();
		
		history.pushState(null, '', displayUrlString);
		
		FacetFiltersForm.renderSectionFromFetch(fetchUrlString, event);
	}

	updateActiveFilter() {
		if (!this.collectionTagFiltersContainer) return;
		
		const links = Array.from(this.collectionTagFiltersContainer.querySelectorAll('custom-link'));
		if (links.length === 0) return;

		// Cache URL parsing - create URL object only once
		const currentUrl = new URL(document.location);
		const urlArray = currentUrl.pathname.split('/');
		const tagsFromUrl = urlArray[urlArray.length - 1];
		const typeFromUrl = currentUrl.searchParams.getAll("filter.p.product_type");
		const filteredCollection = currentUrl.searchParams.get("filtered-collection");
		
		// Cache constants outside the loop
		const hasNoTags = !tagsFromUrl;
		const hasNoTypes = typeFromUrl.length === 0;
		
		let noActiveFilters = true;

		// Process each link
		for (let idx = 0; idx < links.length; idx++) {
			const el = links[idx];
			el.classList.remove('active');

			// Cache data attributes
			const tagNames = el.dataset.filteringTags || '';
			const typesStr = el.getAttribute('data-filtering-types');
			const typeEl = typesStr ? typesStr.split(',').map(t => t.trim()).filter(Boolean) : [];
			const showCollectionHandle = el.getAttribute('data-show-collection-handle');

			// Check if this is "Show All" button (first element with no filters)
			const isShowAllBtn = idx === 0;
			const isShowAllBtnActive = hasNoTags && hasNoTypes && isShowAllBtn && !filteredCollection;

			// Check if link matches current filters
			let isLinkActive = false;
			
			if (isShowAllBtnActive) {
				isLinkActive = true;
			} else {
				const isTagMatch = tagsFromUrl === tagNames;
				const isTypeMatch = typeFromUrl.length === typeEl.length && 
					this.arraysEqualUnordered(typeFromUrl, typeEl);
				const isCollectionMatch = showCollectionHandle ? 
					filteredCollection === showCollectionHandle : 
					!filteredCollection;

				// Link is active if tag, type and collection all match
				isLinkActive = isTagMatch && isTypeMatch && isCollectionMatch;
			}

			if (isLinkActive) {
				noActiveFilters = false;
				el.classList.add('active');
				this.updateShowMoreBtn(el);
			}
		}

		// Fallback: activate first link if no matches found
		if (noActiveFilters && links[0]) {
			links[0].classList.add('active');
			this.updateShowMoreBtn(links[0]);
		}
	}
	arraysEqualUnordered(arr1, arr2) {
		if (arr1.length !== arr2.length) return false;

		const sortedArr1 = arr1.slice().sort();
		const sortedArr2 = arr2.slice().sort();

		for (let i = 0; i < sortedArr1.length; i++) {
			if (sortedArr1[i] !== sortedArr2[i]) return false;
		}
	
		return true; 
	}

	updateShowMoreBtn(activeFilter) {
		const showMoreBtn = document.querySelector('.collection-show-more-btn.button');
		const isShopAll = activeFilter.dataset.showMoreText === 'shop all';
		const parentSection = activeFilter.closest('.collection-tag-filters-section');
		parentSection.classList.toggle('active-filter', !isShopAll);
		if (!showMoreBtn) return;
		showMoreBtn.textContent = isShopAll ? '' : activeFilter.dataset.showMoreText;
		showMoreBtn.href = activeFilter.dataset.showMoreUrl;

		const isPaginationActive = activeFilter.classList.contains("pagination-wrapper-inactive");
		parentSection.classList.toggle("pagination-wrapper-inactive", isPaginationActive)
	}

	disconnectedCallback() {
		if (this.link && this.handleClick) {
			this.link.removeEventListener('click', this.handleClick);
		}
	}
}
customElements.define('custom-link', CustomLink);

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('input').forEach((element) =>
			element.addEventListener('change', this.onRangeChange.bind(this)),
		);

		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll('input');
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute('max', maxInput.value);
		if (minInput.value) maxInput.setAttribute('min', minInput.value);
		if (minInput.value === '') maxInput.setAttribute('min', 0);
		if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute('min'));
		const max = Number(input.getAttribute('max'));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}
}

customElements.define('price-range', PriceRange);

class PriceRangeSlider extends HTMLElement {
	constructor() {
		super();
		this.form = this.closest('form');

		this.slider = this.querySelector('.price-range-slider__slider');
		this.minInput = this.querySelector('.price-range-slider__input--min');
		this.maxInput = this.querySelector('.price-range-slider__input--max');
		this.range = this.querySelector('.price-range-slider__range');
		this.track = this.querySelector('.price-range-slider__track');

		this.minInputLabel = this.querySelector('.price-range-slider__label-min span');
		this.maxInputLabel = this.querySelector('.price-range-slider__label-max span');

		this.form.addEventListener(
			'reset',
			window.queueMicrotask.bind(window, this.updateRange.bind(this)),
		);

		this.minInput.addEventListener('input', this.updateRange.bind(this));
		this.maxInput.addEventListener('input', this.updateRange.bind(this));

		this.slider.addEventListener('click', this.onSliderClick.bind(this));

		this.updateRange();
	}

	updateRange() {
		const min = parseInt(this.minInput.value);
		const max = parseInt(this.maxInput.value);
		const rangeMin = this.minInput.min;
		const rangeMax = this.maxInput.max;

		if (min > max) {
			this.minInput.value = max;
			this.maxInput.value = min;
		}

		const percentMin = ((min - rangeMin) / (rangeMax - rangeMin)) * 100;
		const percentMax = ((max - rangeMin) / (rangeMax - rangeMin)) * 100;

		this.range.style.left = percentMin + '%';
		this.range.style.right = 100 - percentMax + '%';

		this.minInputLabel.innerText = this.minInput.value;
		this.maxInputLabel.innerText = this.maxInput.value;
	}

	onSliderClick(event) {
		if (event.target.matches('.price-range-slider__input')) return;

		const clickX = event.clientX;
		const trackRect = this.track.getBoundingClientRect();
		const clickPercent = (clickX - trackRect.left) / trackRect.width;
		const clickValue =
			parseInt(this.minInput.min) + clickPercent * (this.maxInput.max - this.minInput.min);

		const minDiff = Math.abs(parseInt(this.minInput.value) - clickValue);
		const maxDiff = Math.abs(parseInt(this.maxInput.value) - clickValue);

		if (minDiff < maxDiff) {
			this.minInput.value = clickValue;
		} else {
			this.maxInput.value = clickValue;
		}

		this.updateRange();
	}
}

customElements.define('price-range-slider', PriceRangeSlider);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		this.querySelector('a').addEventListener('click', (event) => {
			event.preventDefault();
			const form =
				this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
			form.onActiveFilterClick(event);
		});
	}
}

customElements.define('facet-remove', FacetRemove);

class SortSelect extends HTMLElement {
	constructor() {
		super();
		this.select = this.querySelector('select');
		this.options = [...this.select.querySelectorAll('option')];

		this.sortOptions();
	}

	sortOptions() {
		const sortOrders = [
			'manual',
			'best-selling',
			'price-ascending',
			'price-descending',
			'title-ascending',
			'title-descending',
			'created-descending',
			'created-ascending',
		];
		if (this.options.length !== sortOrders.length) return;
		const sortedOptions = sortOrders.map((sortOrder) =>
			this.options.find((option) => option.value === sortOrder),
		);

		const filterOptions = sortedOptions.filter((option) => option);

		this.select.innerHTML = filterOptions.map((option) => option.outerHTML).join('');
	}
}

customElements.define('sort-select', SortSelect);



